<h1 class="_primary cell shrink"[i18nKey]="'mail.box.title'"></h1>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-y">
    <div class="cell auto grid-y cell-block-y blockContent">
        <div class="cell auto grid-x grid-padding-x mailBox">
            <div class="cell small-8 xlarge-12 grid-x mailBoxResponsive">
                <div class="cell small-8 mailBox-actions _separator">
                    <button (click)="onSelectNewMessage()" class="button _primary _small _iconLeft" [captureId]="'new-message'">
                        <i class="fas fa-plus"></i> <span [i18nKey]="'mail.box.new.message'"></span></button>
                    <nav>
                        <ul>
                            <li [class._active]="displayReceivedMessages" (click)="onSelectReceivedMessages()">
                                <span><i class="fas fa-inbox"></i> <span [i18nKey]="'mail.box.reception'"></span></span>
                            </li>
                            <li [class._active]="displaySentMessages" (click)="onSelectSentMessages()">
                                <span><i class="far fa-paper-plane"></i> <span [i18nKey]="'mail.box.send'"></span></span>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div *ngIf="displayReceivedMessages"
                     class="cell small-16 grid-y mailBox-list _separator">
                    <kiwi-messages-list
                        (messageSelected)="onSelectMessage($event)"
                        (indexSelected)="onSelectReceivedMessage($event)"
                        [messagesLoader]="receivedMessagesLoaderService"
                        [reload]="reloadReceivedMessages"
                        [displayUnreadStatus]="true"
                        class="cell auto cell-block-y">
                    </kiwi-messages-list>
                </div>
                <div *ngIf="displaySentMessages"
                     class="cell small-16 grid-y mailBox-list _separator">
                    <kiwi-messages-list
                        (messageSelected)="onSelectMessage($event)"
                        [messagesLoader]="sentMessagesLoaderService"
                        class="cell auto cell-block-y">
                    </kiwi-messages-list>
                </div>

                <div *ngIf="newMessage" class="cell small-16 grid-y mailBox-contacts _separator">
                    <kiwi-address-book *ngIf="newMessage" class="cell auto cell-block-y"
                                       (addRecipients)="onNewRecipients($event)"></kiwi-address-book>
                </div>
            </div>
            <div class="cell small-12 grid-y">
                <kiwi-message-content *ngIf="selectedMessage && !newMessage"
                                      [displayActions]="displayReceivedMessages"
                                      [message]="selectedMessage"
                                      (messageDeleted)="onDeleteMessage($event)"
                                      (answerTo)="onAnswerTo($event)"></kiwi-message-content>
                <kiwi-new-message *ngIf="newMessage" [recipients]="recipients"
                                  (usersListDeleted)="onRecipientsDeleted($event)"
                                  (messageSent)="onMessageSent($event)"></kiwi-new-message>
            </div>
        </div>
    </div>
</div>
